"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mountIsland_1 = require("../mountIsland");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var Lang_js_1 = require("../Lang.js");
var NAVY = '#1c1c3c';
var TwiCancelPage = function () {
    return (react_1.default.createElement(Box_1.default, { sx: {
            p: 2, maxWidth: '560px', mx: 'auto', mt: { xs: 2, sm: 6 },
            backgroundColor: '#f5f6f8',
        } },
        react_1.default.createElement(Paper_1.default, { elevation: 0, sx: {
                p: { xs: '28px 20px', sm: '48px' },
                borderRadius: 2,
                backgroundColor: '#fff',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                textAlign: 'center',
            } },
            react_1.default.createElement(Box_1.default, { sx: {
                    width: '64px', height: '64px', borderRadius: '50%',
                    backgroundColor: 'rgba(28,28,60,0.06)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    mx: 'auto', mb: 3, fontSize: '28px',
                } }, "\uD83C\uDFAC"),
            react_1.default.createElement(Typography_1.default, { variant: "inherit", component: "h1", sx: { m: 0, fontSize: '22px', fontWeight: 700, color: NAVY, lineHeight: 1.2 } }, (0, Lang_js_1.__)('No problem!')),
            react_1.default.createElement(Typography_1.default, { sx: { mt: 1.5, fontSize: '15px', color: '#555', lineHeight: 1.6 } }, (0, Lang_js_1.__)('You didn\'t complete the subscription. You can subscribe to TWI anytime — your content will be waiting for you.')),
            react_1.default.createElement(Box_1.default, { sx: { mt: 3, display: 'flex', flexDirection: 'column', gap: 1.5 } },
                react_1.default.createElement(Box_1.default, { component: "a", href: "/app/twi/subscribe", sx: {
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        height: '46px', borderRadius: '6px',
                        backgroundColor: NAVY, color: '#fff',
                        fontSize: '14px', fontWeight: 700, textDecoration: 'none',
                        '&:hover': { backgroundColor: '#2a2a4c', textDecoration: 'none', color: '#fff' },
                    } }, (0, Lang_js_1.__)('View Subscription Plans')),
                react_1.default.createElement(Box_1.default, { component: "a", href: "/app/subscriptions/manage", sx: {
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        height: '42px', borderRadius: '6px',
                        border: "2px solid ".concat(NAVY), color: NAVY,
                        fontSize: '14px', fontWeight: 700, textDecoration: 'none',
                        '&:hover': { backgroundColor: 'rgba(28,28,60,0.04)', textDecoration: 'none', color: NAVY },
                    } }, (0, Lang_js_1.__)('Back to Subscriptions'))))));
};
var twiCancelEl = document.getElementById('twi-cancel-page');
if (twiCancelEl) {
    (0, mountIsland_1.mountIsland)(twiCancelEl, react_1.default.createElement(TwiCancelPage, null));
}
exports.default = TwiCancelPage;
